/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Create_Validation_Fundrequired2Inputs */

const en_coinvestments_create_validation_fundrequired2 = /** @type {(inputs: Coinvestments_Create_Validation_Fundrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund is required`)
};

/**
* | output |
* | --- |
* | "Fund is required" |
*
* @param {Coinvestments_Create_Validation_Fundrequired2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_create_validation_fundrequired2 = /** @type {((inputs?: Coinvestments_Create_Validation_Fundrequired2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Create_Validation_Fundrequired2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_create_validation_fundrequired2(inputs)
});
export { coinvestments_create_validation_fundrequired2 as "coInvestments_create_validation_fundRequired" }